import { friendlyErrorMessage } from '@/core/lib/dbError'

import { generateDocument } from '@/core/api/documents'
import { ok, technical, type Result } from '@/core/lib/result'

export async function renderBescheinigung(coachingId: string): Promise<Result<void>> {
  try {
    await generateDocument('bescheinigung', { coaching_id: coachingId })
    return ok(undefined)
  } catch (error) {
    return technical(friendlyErrorMessage(error, "Bescheinigung konnte nicht erstellt werden."))
  }
}
